import httpClient from '../lib/httpClient';

// API endpoints for operators (read-only)
const apiPath = 'api/spaces';

// Admin endpoints for full CRUD
const adminPath = 'admin/spaces';

// Read operations - use /api (operators + admins)
export const listSpaces = (query) => httpClient.get(apiPath, { query });
export const getSpace = (id) => httpClient.get(`${apiPath}/${id}`);
export const getSpaceNodes = (spaceId) => httpClient.get(`${apiPath}/${spaceId}/nodes`);
export const getNodeProducts = (nodeId) => httpClient.get(`api/nodes/${nodeId}/products`);

// Build full tree structure (spaces -> nodes -> products)
export const getSpacesTree = async () => {
  const spaces = await listSpaces();
  const spacesArray = Array.isArray(spaces) ? spaces : [];
  
  const tree = await Promise.all(
    spacesArray.map(async (space) => {
      const nodes = await getSpaceNodes(space.id);
      const nodesArray = Array.isArray(nodes) ? nodes : [];
      
      const stations = await Promise.all(
        nodesArray.map(async (node) => {
          const products = await getNodeProducts(node.id);
          return {
            ...node,
            products: Array.isArray(products) ? products : [],
          };
        })
      );
      
      return {
        ...space,
        stations,
      };
    })
  );
  
  return tree;
};

// Write operations - use /admin (admins only)
export const createSpace = (payload) => httpClient.post(adminPath, payload);
export const updateSpace = (id, payload) => httpClient.put(`${adminPath}/${id}`, payload);
export const deleteSpace = (id) => httpClient.del(`${adminPath}/${id}`);
export const toggleSpaceStatus = (id) => httpClient.put(`${adminPath}/${id}/status`, {});

const spaceServiceExport = { 
  listSpaces, 
  getSpace, 
  getSpaceNodes, 
  getNodeProducts, 
  getSpacesTree,
  createSpace, 
  updateSpace, 
  deleteSpace, 
  toggleSpaceStatus 
};
export default spaceServiceExport;
